import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell, { type MinimalRailItem, type MinimalRailShell } from "~/components/dock/minimalRailShell";
import { translateWithActiveLanguage } from "~/helpers/localizedText";

const baseGrowerBenchmarksRailItems: MinimalRailItem[] = [
	{
		icon: "leaderboard",
		id: "home",
		path: "/benchmark",
		title: translateWithActiveLanguage("nav.benchmark.home.label")
	},
	{
		icon: "assessment",
		id: "results",
		path: "/benchmark/results",
		title: translateWithActiveLanguage("nav.benchmark.results.label")
	},
	{
		icon: "compare_arrows",
		id: "compare",
		path: "/benchmark/compare",
		title: translateWithActiveLanguage("nav.benchmark.compare.label")
	}
];

const queueGrowerBenchmarksRailItem: MinimalRailItem = {
	icon: "rate_review",
	id: "reviews",
	path: "/benchmark/reviews",
	title: translateWithActiveLanguage("nav.benchmark.reviews.label")
};

const consoleScreenRailItems: MinimalRailItem[] = [
	{
		icon: "groups",
		id: "console-members",
		path: "/benchmark/console/members",
		title: translateWithActiveLanguage("nav.benchmark.console.members.label")
	},
	{
		icon: "badge",
		id: "console-roster",
		path: "/benchmark/console/roster",
		title: translateWithActiveLanguage("nav.benchmark.console.roster.label")
	},
	{
		icon: "manage_search",
		id: "console-lookup",
		path: "/benchmark/console/lookup",
		title: translateWithActiveLanguage("nav.benchmark.console.lookup.label")
	},
	{
		icon: "receipt_long",
		id: "console-billing",
		path: "/benchmark/console/billing",
		title: translateWithActiveLanguage("nav.benchmark.console.billing.label")
	},
	{
		icon: "history",
		id: "console-access-log",
		path: "/benchmark/console/access-log",
		title: translateWithActiveLanguage("nav.benchmark.console.accessLog.label")
	}
];

const analystConsoleRailItems: MinimalRailItem[] = [
	{
		icon: "tune",
		id: "console-metrics",
		path: "/benchmark/console/metrics",
		title: translateWithActiveLanguage("nav.benchmark.console.metricCatalog.label")
	},
	{
		icon: "table_chart",
		id: "console-cohorts",
		path: "/benchmark/console/cohorts",
		title: translateWithActiveLanguage("nav.benchmark.console.cohortTables.label")
	}
];

const rosterRailItems: MinimalRailItem[] = [queueGrowerBenchmarksRailItem, ...consoleScreenRailItems];

export const growerBenchmarksRail = buildMinimalRailShell(
	ApplicationEnum.BENCHMARK,
	baseGrowerBenchmarksRailItems,
	"leaderboard"
);

export const growerBenchmarksRosterRail = buildMinimalRailShell(
	ApplicationEnum.BENCHMARK,
	[...baseGrowerBenchmarksRailItems, ...rosterRailItems],
	"leaderboard"
);

export const growerBenchmarksAnalystRail = buildMinimalRailShell(
	ApplicationEnum.BENCHMARK,
	[...baseGrowerBenchmarksRailItems, ...analystConsoleRailItems],
	"leaderboard"
);

export const growerBenchmarksAnalystAndRosterRail = buildMinimalRailShell(
	ApplicationEnum.BENCHMARK,
	[...baseGrowerBenchmarksRailItems, ...rosterRailItems, ...analystConsoleRailItems],
	"leaderboard"
);

export const getGrowerBenchmarksRailShell = (hasConsoleAccess: boolean, hasRosterAccess = false): MinimalRailShell => {
	if (hasConsoleAccess && hasRosterAccess) return growerBenchmarksAnalystAndRosterRail;
	if (hasConsoleAccess) return growerBenchmarksAnalystRail;
	if (hasRosterAccess) return growerBenchmarksRosterRail;
	return growerBenchmarksRail;
};

export default growerBenchmarksRail;
